// Sanitises router paths before they are sent to analytics, so document IDs
// (patient IDs, prospect IDs, Firebase UIDs) and email-bearing query-ish
// segments never leave the app. Analytics receives route *shapes*, not routes.

// Firestore auto-IDs are 20 chars, Firebase Auth UIDs 28; both alphanumeric
// and effectively always contain digits. Requiring a digit stops hyphenated
// route words ("provider-sign-in") from being mistaken for IDs.
const ID_LIKE = /^[A-Za-z0-9_-]{16,}$/;
const HAS_DIGIT = /\d/;
const NUMERIC_ID = /^\d{4,}$/;
const EMAIL_LIKE = /@|%40/;

export function sanitizeRoutePath(pathname) {
  if (typeof pathname !== 'string' || pathname === '') return '/';
  const sanitized = pathname
    .split('/')
    .map((segment) => {
      if (segment === '') return segment;
      const decoded = (() => {
        try {
          return decodeURIComponent(segment);
        } catch (_) {
          return segment;
        }
      })();
      if (EMAIL_LIKE.test(decoded)) return ':param';
      if ((ID_LIKE.test(segment) && HAS_DIGIT.test(segment)) || NUMERIC_ID.test(segment)) {
        return ':id';
      }
      return segment;
    })
    .join('/');
  return sanitized || '/';
}
